"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FLAPI_NO = exports.SrvType = exports.NotifType = exports.ParameterOption = exports.FLWHFIELDIDX_EVALID = exports.FLWebHookStatus = exports.FLWHFIELDIDX_SMS = exports.FLWHFIELDIDX_MAIL = exports.FLWHFIELDIDX_COMMON = exports.FLSvcStatus = exports.ProcessWHIdEnum = exports.backupFreqEnum = exports.flDateUnitEnum = exports.flWHStatusEnum = exports.flMQStatusEnum = exports.flSystemTypeEnum = exports.fDelayUnitEnum = exports.flUserType = exports.flSpeProcess = exports.flFeatureBits = exports.flTraceEnum = exports.flCacheReliability = exports.accEnum = exports.ITypeObject = void 0;
var ITypeObject;
(function (ITypeObject) {
    ITypeObject["APPLICATION"] = "application";
    ITypeObject["CALC"] = "calc";
    ITypeObject["ENTITY"] = "entity";
    ITypeObject["FREEJSON"] = "freejson";
    ITypeObject["JSON"] = "json";
    ITypeObject["LINKEDFIELD"] = "linkedField";
    ITypeObject["NUMBER"] = "number";
    ITypeObject["POINTER"] = "pointer";
    ITypeObject["ROLLUP"] = "rollup";
    ITypeObject["STRING"] = "string";
    ITypeObject["USER"] = "user";
    ITypeObject["USERID"] = "uid";
})(ITypeObject = exports.ITypeObject || (exports.ITypeObject = {}));
var accEnum;
(function (accEnum) {
    accEnum[accEnum["NONE"] = 0] = "NONE";
    accEnum[accEnum["INSERT"] = 2] = "INSERT";
    accEnum[accEnum["READ"] = 4] = "READ";
    accEnum[accEnum["WRITE"] = 8] = "WRITE";
    accEnum[accEnum["DELETE"] = 16] = "DELETE";
    accEnum[accEnum["FULLRW"] = 30] = "FULLRW";
    accEnum[accEnum["DESIGN"] = 62] = "DESIGN";
    accEnum[accEnum["ADMIN"] = 255] = "ADMIN";
    accEnum[accEnum["GETOWNDATAONLY"] = 512] = "GETOWNDATAONLY";
    accEnum[accEnum["FLADMIN"] = 3583] = "FLADMIN";
})(accEnum = exports.accEnum || (exports.accEnum = {}));
var flCacheReliability;
(function (flCacheReliability) {
    flCacheReliability[flCacheReliability["green"] = 1] = "green";
    flCacheReliability[flCacheReliability["orange"] = 5] = "orange";
    flCacheReliability[flCacheReliability["red"] = 9] = "red";
})(flCacheReliability = exports.flCacheReliability || (exports.flCacheReliability = {}));
var flTraceEnum;
(function (flTraceEnum) {
    flTraceEnum[flTraceEnum["nothing"] = 0] = "nothing";
    flTraceEnum[flTraceEnum["debug"] = 1] = "debug";
    flTraceEnum[flTraceEnum["infra"] = 2] = "infra";
    flTraceEnum[flTraceEnum["access"] = 4] = "access";
    flTraceEnum[flTraceEnum["call"] = 8] = "call";
    flTraceEnum[flTraceEnum["db"] = 16] = "db";
    flTraceEnum[flTraceEnum["bkgWork"] = 32] = "bkgWork";
    flTraceEnum[flTraceEnum["notif"] = 64] = "notif";
    flTraceEnum[flTraceEnum["locks"] = 128] = "locks";
    flTraceEnum[flTraceEnum["session"] = 256] = "session";
    flTraceEnum[flTraceEnum["dbCalls"] = 512] = "dbCalls";
    flTraceEnum[flTraceEnum["dico"] = 1024] = "dico";
    flTraceEnum[flTraceEnum["svc"] = 2048] = "svc";
    flTraceEnum[flTraceEnum["checkHdl"] = 4096] = "checkHdl";
    flTraceEnum[flTraceEnum["restcalls"] = 8192] = "restcalls";
    flTraceEnum[flTraceEnum["exec"] = 16384] = "exec";
    flTraceEnum[flTraceEnum["perf"] = 32768] = "perf";
    flTraceEnum[flTraceEnum["processExit"] = 65536] = "processExit";
    flTraceEnum[flTraceEnum["all"] = 4294967295] = "all";
})(flTraceEnum = exports.flTraceEnum || (exports.flTraceEnum = {}));
var flFeatureBits;
(function (flFeatureBits) {
    flFeatureBits[flFeatureBits["EmailFixedSender"] = 1] = "EmailFixedSender";
    flFeatureBits[flFeatureBits["EmailLimit1Senders"] = 2] = "EmailLimit1Senders";
    flFeatureBits[flFeatureBits["EmailLimit2Senders"] = 4] = "EmailLimit2Senders";
    flFeatureBits[flFeatureBits["EmailOwnAccount"] = 8] = "EmailOwnAccount";
})(flFeatureBits = exports.flFeatureBits || (exports.flFeatureBits = {}));
var flSpeProcess;
(function (flSpeProcess) {
    flSpeProcess[flSpeProcess["DISPLAY"] = 1] = "DISPLAY";
    flSpeProcess[flSpeProcess["SYNC"] = 2] = "SYNC";
    flSpeProcess[flSpeProcess["PARAM"] = 4] = "PARAM";
    flSpeProcess[flSpeProcess["AUTOLOAD"] = 8] = "AUTOLOAD";
})(flSpeProcess = exports.flSpeProcess || (exports.flSpeProcess = {}));
var flUserType;
(function (flUserType) {
    flUserType[flUserType["UNKNOWN"] = 0] = "UNKNOWN";
    flUserType[flUserType["USER"] = 1] = "USER";
    flUserType[flUserType["ADMIN"] = 2] = "ADMIN";
})(flUserType = exports.flUserType || (exports.flUserType = {}));
var fDelayUnitEnum;
(function (fDelayUnitEnum) {
    fDelayUnitEnum[fDelayUnitEnum["HOURS"] = 1] = "HOURS";
    fDelayUnitEnum[fDelayUnitEnum["DAYS"] = 2] = "DAYS";
    fDelayUnitEnum[fDelayUnitEnum["MONTH"] = 3] = "MONTH";
    fDelayUnitEnum[fDelayUnitEnum["YEAR"] = 4] = "YEAR";
})(fDelayUnitEnum = exports.fDelayUnitEnum || (exports.fDelayUnitEnum = {}));
var flSystemTypeEnum;
(function (flSystemTypeEnum) {
    flSystemTypeEnum[flSystemTypeEnum["STRING"] = 0] = "STRING";
    flSystemTypeEnum[flSystemTypeEnum["NUMBER"] = 1] = "NUMBER";
    flSystemTypeEnum[flSystemTypeEnum["POINTER"] = 2] = "POINTER";
    flSystemTypeEnum[flSystemTypeEnum["UID"] = 3] = "UID";
    flSystemTypeEnum[flSystemTypeEnum["CALC"] = 4] = "CALC";
    flSystemTypeEnum[flSystemTypeEnum["JSON"] = 5] = "JSON";
    flSystemTypeEnum[flSystemTypeEnum["FREEJSON"] = 6] = "FREEJSON";
    flSystemTypeEnum[flSystemTypeEnum["LINKEDFIELD"] = 7] = "LINKEDFIELD";
    flSystemTypeEnum[flSystemTypeEnum["ROLLUP"] = 8] = "ROLLUP";
    flSystemTypeEnum[flSystemTypeEnum["OTHER"] = 99] = "OTHER";
})(flSystemTypeEnum = exports.flSystemTypeEnum || (exports.flSystemTypeEnum = {}));
var flMQStatusEnum;
(function (flMQStatusEnum) {
    flMQStatusEnum[flMQStatusEnum["INLOCALQUEUE"] = 1] = "INLOCALQUEUE";
    flMQStatusEnum[flMQStatusEnum["INPROVIDERQUEUE"] = 2] = "INPROVIDERQUEUE";
    flMQStatusEnum[flMQStatusEnum["INPROCESS"] = 3] = "INPROCESS";
    flMQStatusEnum[flMQStatusEnum["ERROR"] = 9] = "ERROR";
    flMQStatusEnum[flMQStatusEnum["DONE"] = 99] = "DONE";
})(flMQStatusEnum = exports.flMQStatusEnum || (exports.flMQStatusEnum = {}));
var flWHStatusEnum;
(function (flWHStatusEnum) {
    flWHStatusEnum[flWHStatusEnum["RECEIVED"] = 1] = "RECEIVED";
    flWHStatusEnum[flWHStatusEnum["ROUTED"] = 4] = "ROUTED";
    flWHStatusEnum[flWHStatusEnum["DONE"] = 9] = "DONE";
    flWHStatusEnum[flWHStatusEnum["ERROR"] = 99] = "ERROR";
})(flWHStatusEnum = exports.flWHStatusEnum || (exports.flWHStatusEnum = {}));
var flDateUnitEnum;
(function (flDateUnitEnum) {
    flDateUnitEnum[flDateUnitEnum["HOUR"] = 1] = "HOUR";
    flDateUnitEnum[flDateUnitEnum["DAY"] = 2] = "DAY";
    flDateUnitEnum[flDateUnitEnum["MONTH"] = 3] = "MONTH";
    flDateUnitEnum[flDateUnitEnum["YEAR"] = 4] = "YEAR";
    flDateUnitEnum[flDateUnitEnum["FIRSTDAYNEXTMONTH"] = 10] = "FIRSTDAYNEXTMONTH";
    flDateUnitEnum[flDateUnitEnum["LASTDAYNEXTMONTH"] = 11] = "LASTDAYNEXTMONTH";
    flDateUnitEnum[flDateUnitEnum["TEST"] = 99] = "TEST";
})(flDateUnitEnum = exports.flDateUnitEnum || (exports.flDateUnitEnum = {}));
var backupFreqEnum;
(function (backupFreqEnum) {
    backupFreqEnum[backupFreqEnum["NO"] = 0] = "NO";
    backupFreqEnum[backupFreqEnum["MONTHLY"] = 1] = "MONTHLY";
    backupFreqEnum[backupFreqEnum["WEEKLY"] = 2] = "WEEKLY";
    backupFreqEnum[backupFreqEnum["DAILY"] = 3] = "DAILY";
})(backupFreqEnum = exports.backupFreqEnum || (exports.backupFreqEnum = {}));
var ProcessWHIdEnum;
(function (ProcessWHIdEnum) {
    ProcessWHIdEnum[ProcessWHIdEnum["INSERT"] = 1] = "INSERT";
    ProcessWHIdEnum[ProcessWHIdEnum["MAINTAIN"] = 2] = "MAINTAIN";
    ProcessWHIdEnum[ProcessWHIdEnum["UPDATE"] = 3] = "UPDATE";
    ProcessWHIdEnum[ProcessWHIdEnum["PUSH"] = 4] = "PUSH";
    ProcessWHIdEnum[ProcessWHIdEnum["SVCEXEC"] = 5] = "SVCEXEC";
    ProcessWHIdEnum[ProcessWHIdEnum["SUMPUP"] = 6] = "SUMPUP";
    ProcessWHIdEnum[ProcessWHIdEnum["EMAILVALID"] = 7] = "EMAILVALID";
})(ProcessWHIdEnum = exports.ProcessWHIdEnum || (exports.ProcessWHIdEnum = {}));
var FLSvcStatus;
(function (FLSvcStatus) {
    FLSvcStatus[FLSvcStatus["WAIT"] = 0] = "WAIT";
    FLSvcStatus[FLSvcStatus["QUEUED"] = 1] = "QUEUED";
    FLSvcStatus[FLSvcStatus["TRUECOND"] = 97] = "TRUECOND";
    FLSvcStatus[FLSvcStatus["FALSECOND"] = 98] = "FALSECOND";
    FLSvcStatus[FLSvcStatus["ERROR"] = 99] = "ERROR";
})(FLSvcStatus = exports.FLSvcStatus || (exports.FLSvcStatus = {}));
var FLWHFIELDIDX_COMMON;
(function (FLWHFIELDIDX_COMMON) {
    FLWHFIELDIDX_COMMON[FLWHFIELDIDX_COMMON["ID"] = 0] = "ID";
    FLWHFIELDIDX_COMMON[FLWHFIELDIDX_COMMON["REQUESTID"] = 1] = "REQUESTID";
    FLWHFIELDIDX_COMMON[FLWHFIELDIDX_COMMON["KEY"] = 2] = "KEY";
    FLWHFIELDIDX_COMMON[FLWHFIELDIDX_COMMON["GROUPKEY"] = 3] = "GROUPKEY";
    FLWHFIELDIDX_COMMON[FLWHFIELDIDX_COMMON["INSTANCENO"] = 4] = "INSTANCENO";
    FLWHFIELDIDX_COMMON[FLWHFIELDIDX_COMMON["SVCSTATUS"] = 5] = "SVCSTATUS";
    FLWHFIELDIDX_COMMON[FLWHFIELDIDX_COMMON["ERRORFIRSTDATE"] = 6] = "ERRORFIRSTDATE";
    FLWHFIELDIDX_COMMON[FLWHFIELDIDX_COMMON["QUEUEDATE"] = 7] = "QUEUEDATE";
    FLWHFIELDIDX_COMMON[FLWHFIELDIDX_COMMON["HISTO"] = 8] = "HISTO";
    FLWHFIELDIDX_COMMON[FLWHFIELDIDX_COMMON["NEXTSLOT"] = 9] = "NEXTSLOT";
})(FLWHFIELDIDX_COMMON = exports.FLWHFIELDIDX_COMMON || (exports.FLWHFIELDIDX_COMMON = {}));
var FLWHFIELDIDX_MAIL;
(function (FLWHFIELDIDX_MAIL) {
    FLWHFIELDIDX_MAIL[FLWHFIELDIDX_MAIL["TO"] = 9] = "TO";
    FLWHFIELDIDX_MAIL[FLWHFIELDIDX_MAIL["READFIRSTDATE"] = 10] = "READFIRSTDATE";
    FLWHFIELDIDX_MAIL[FLWHFIELDIDX_MAIL["CLICKFIRSTDATE"] = 11] = "CLICKFIRSTDATE";
    FLWHFIELDIDX_MAIL[FLWHFIELDIDX_MAIL["CLICINFO"] = 12] = "CLICINFO";
    FLWHFIELDIDX_MAIL[FLWHFIELDIDX_MAIL["SPAMDATE"] = 13] = "SPAMDATE";
    FLWHFIELDIDX_MAIL[FLWHFIELDIDX_MAIL["BOUNCEDATE"] = 14] = "BOUNCEDATE";
    FLWHFIELDIDX_MAIL[FLWHFIELDIDX_MAIL["UNSUBDATE"] = 15] = "UNSUBDATE";
})(FLWHFIELDIDX_MAIL = exports.FLWHFIELDIDX_MAIL || (exports.FLWHFIELDIDX_MAIL = {}));
var FLWHFIELDIDX_SMS;
(function (FLWHFIELDIDX_SMS) {
    FLWHFIELDIDX_SMS[FLWHFIELDIDX_SMS["TO"] = 9] = "TO";
    FLWHFIELDIDX_SMS[FLWHFIELDIDX_SMS["DELIVEREDATE"] = 10] = "DELIVEREDATE";
    FLWHFIELDIDX_SMS[FLWHFIELDIDX_SMS["PHONECOMPANY"] = 11] = "PHONECOMPANY";
    FLWHFIELDIDX_SMS[FLWHFIELDIDX_SMS["UNITS"] = 12] = "UNITS";
    FLWHFIELDIDX_SMS[FLWHFIELDIDX_SMS["TOTALAMOUNT"] = 13] = "TOTALAMOUNT";
    FLWHFIELDIDX_SMS[FLWHFIELDIDX_SMS["TOTALRATE"] = 14] = "TOTALRATE";
})(FLWHFIELDIDX_SMS = exports.FLWHFIELDIDX_SMS || (exports.FLWHFIELDIDX_SMS = {}));
var FLWebHookStatus;
(function (FLWebHookStatus) {
    FLWebHookStatus[FLWebHookStatus["WAITING"] = 0] = "WAITING";
    FLWebHookStatus[FLWebHookStatus["ROUTED"] = 10] = "ROUTED";
    FLWebHookStatus[FLWebHookStatus["PROCESSED"] = 90] = "PROCESSED";
    FLWebHookStatus[FLWebHookStatus["ERROR"] = 99] = "ERROR";
})(FLWebHookStatus = exports.FLWebHookStatus || (exports.FLWebHookStatus = {}));
var FLWHFIELDIDX_EVALID;
(function (FLWHFIELDIDX_EVALID) {
    FLWHFIELDIDX_EVALID[FLWHFIELDIDX_EVALID["EMAIL"] = 9] = "EMAIL";
    FLWHFIELDIDX_EVALID[FLWHFIELDIDX_EVALID["VALIDATED"] = 10] = "VALIDATED";
    FLWHFIELDIDX_EVALID[FLWHFIELDIDX_EVALID["VALIDATIONDATE"] = 11] = "VALIDATIONDATE";
})(FLWHFIELDIDX_EVALID = exports.FLWHFIELDIDX_EVALID || (exports.FLWHFIELDIDX_EVALID = {}));
var ParameterOption;
(function (ParameterOption) {
    ParameterOption[ParameterOption["NONE"] = 0] = "NONE";
    ParameterOption[ParameterOption["AUTOLOAD"] = 1] = "AUTOLOAD";
})(ParameterOption = exports.ParameterOption || (exports.ParameterOption = {}));
var NotifType;
(function (NotifType) {
    NotifType[NotifType["SYSTEM"] = 1] = "SYSTEM";
    NotifType[NotifType["DATA"] = 2] = "DATA";
    NotifType[NotifType["SERVICE"] = 4] = "SERVICE";
    NotifType[NotifType["UI"] = 8] = "UI";
    NotifType[NotifType["DICO"] = 32] = "DICO";
    NotifType[NotifType["PARAM"] = 64] = "PARAM";
    NotifType[NotifType["FLCLIENT"] = 128] = "FLCLIENT";
    NotifType[NotifType["ALL"] = 255] = "ALL";
})(NotifType = exports.NotifType || (exports.NotifType = {}));
var SrvType;
(function (SrvType) {
    SrvType[SrvType["SERVER"] = 1] = "SERVER";
    SrvType[SrvType["MASTER"] = 2] = "MASTER";
    SrvType[SrvType["ADMIN"] = 3] = "ADMIN";
    SrvType[SrvType["FILESERVER"] = 4] = "FILESERVER";
    SrvType[SrvType["WEBHOOK"] = 5] = "WEBHOOK";
})(SrvType = exports.SrvType || (exports.SrvType = {}));
var FLAPI_NO;
(function (FLAPI_NO) {
    FLAPI_NO[FLAPI_NO["LOGIN"] = 1] = "LOGIN";
    FLAPI_NO[FLAPI_NO["TEST"] = 2] = "TEST";
    FLAPI_NO[FLAPI_NO["GETINSTANCES"] = 3] = "GETINSTANCES";
    FLAPI_NO[FLAPI_NO["TOKENREQUIRED"] = 10] = "TOKENREQUIRED";
    FLAPI_NO[FLAPI_NO["USE"] = 19] = "USE";
    FLAPI_NO[FLAPI_NO["LOGOUT"] = 20] = "LOGOUT";
    FLAPI_NO[FLAPI_NO["CLOSEDB"] = 21] = "CLOSEDB";
    FLAPI_NO[FLAPI_NO["PROMOTE"] = 30] = "PROMOTE";
    FLAPI_NO[FLAPI_NO["DEPROMOTE"] = 31] = "DEPROMOTE";
    FLAPI_NO[FLAPI_NO["GETONE"] = 32] = "GETONE";
    FLAPI_NO[FLAPI_NO["GETMANY"] = 33] = "GETMANY";
    FLAPI_NO[FLAPI_NO["LOADTEMPLATE"] = 34] = "LOADTEMPLATE";
    FLAPI_NO[FLAPI_NO["GETTEMPLATE"] = 35] = "GETTEMPLATE";
    FLAPI_NO[FLAPI_NO["REPLACE"] = 36] = "REPLACE";
    FLAPI_NO[FLAPI_NO["UPDATEONE"] = 37] = "UPDATEONE";
    FLAPI_NO[FLAPI_NO["UPDATEMANY"] = 38] = "UPDATEMANY";
    FLAPI_NO[FLAPI_NO["DELETEONE"] = 39] = "DELETEONE";
    FLAPI_NO[FLAPI_NO["DELETEMANY"] = 40] = "DELETEMANY";
    FLAPI_NO[FLAPI_NO["GETLFTEMPLATELIST"] = 41] = "GETLFTEMPLATELIST";
    FLAPI_NO[FLAPI_NO["GETNOTIFS"] = 50] = "GETNOTIFS";
    FLAPI_NO[FLAPI_NO["CHECKDB"] = 60] = "CHECKDB";
    FLAPI_NO[FLAPI_NO["DUMPDB"] = 61] = "DUMPDB";
    FLAPI_NO[FLAPI_NO["RESTOREDB"] = 62] = "RESTOREDB";
    FLAPI_NO[FLAPI_NO["GETDUMPTLIST"] = 63] = "GETDUMPTLIST";
    FLAPI_NO[FLAPI_NO["INSERT"] = 64] = "INSERT";
    FLAPI_NO[FLAPI_NO["GETROLLUP"] = 65] = "GETROLLUP";
    FLAPI_NO[FLAPI_NO["COPYDB"] = 66] = "COPYDB";
    FLAPI_NO[FLAPI_NO["FIXDB"] = 67] = "FIXDB";
    FLAPI_NO[FLAPI_NO["GETNOTIFIFO"] = 68] = "GETNOTIFIFO";
    FLAPI_NO[FLAPI_NO["GETNOTIFDETAIL"] = 69] = "GETNOTIFDETAIL";
    FLAPI_NO[FLAPI_NO["MERGESDOCS"] = 70] = "MERGESDOCS";
    FLAPI_NO[FLAPI_NO["ADMIN_CHECK"] = 90] = "ADMIN_CHECK";
    FLAPI_NO[FLAPI_NO["CRASH_TEST"] = 91] = "CRASH_TEST";
    FLAPI_NO[FLAPI_NO["ADMIN_MGT"] = 92] = "ADMIN_MGT";
    FLAPI_NO[FLAPI_NO["GETSVCINFO"] = 110] = "GETSVCINFO";
    FLAPI_NO[FLAPI_NO["EMAILDIRECT"] = 111] = "EMAILDIRECT";
    FLAPI_NO[FLAPI_NO["NEWPARAM"] = 120] = "NEWPARAM";
    FLAPI_NO[FLAPI_NO["DELETEPARAM"] = 121] = "DELETEPARAM";
    FLAPI_NO[FLAPI_NO["UPDATEPARAMOPTION"] = 122] = "UPDATEPARAMOPTION";
    FLAPI_NO[FLAPI_NO["UPDATEPARAMVALUE"] = 123] = "UPDATEPARAMVALUE";
    FLAPI_NO[FLAPI_NO["GETPARAMSHORT"] = 124] = "GETPARAMSHORT";
    FLAPI_NO[FLAPI_NO["EXECSVC"] = 130] = "EXECSVC";
    FLAPI_NO[FLAPI_NO["GETWHACTION"] = 131] = "GETWHACTION";
    FLAPI_NO[FLAPI_NO["GETWHREQUEST"] = 132] = "GETWHREQUEST";
    FLAPI_NO[FLAPI_NO["GETWHFLTERED"] = 134] = "GETWHFLTERED";
    FLAPI_NO[FLAPI_NO["DELETEGK"] = 135] = "DELETEGK";
    FLAPI_NO[FLAPI_NO["GETWHINFOS"] = 136] = "GETWHINFOS";
    FLAPI_NO[FLAPI_NO["LAST_APINO"] = 137] = "LAST_APINO";
})(FLAPI_NO = exports.FLAPI_NO || (exports.FLAPI_NO = {}));
